import { siteCall } from "../utils/WebCall";
import urls from '../utils/urls'
import moment from "moment";
import { LIMIT } from '../../src/config/Constants'

export const createMeetings = async(params, successCallback, errorCallback) => {
    return siteCall({
        url: urls.meetings_url + "/create",
        method: "POST",
        body: JSON.stringify(params),
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
}


export const partialUpdateMeetings = async(id, params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.meetings_url + "/partial-update/" + id,
      method: "PATCH",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const deleteMeetings = async(id, successCallback, errorCallback) => {
    return siteCall({
        url: urls.meetings_url + "/delete/" + id,
        method: "DELETE",
        body: {},
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
  }


export const getMeetings = async(id, successCallback, errorCallback) => {
  return siteCall({
      url: urls.meetings_url + "/get/" + id,
      method: "GET",
      body: {},
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const getMeetingsWithFilter = async(params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.meetings_url + "/get-all",
      method: "POST",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const fetchMeetings = async (dispatch, page, limit) => {
  page = page || 0;
  limit = limit || LIMIT;
  let filters = {
    "fileDetails.type": {"not-in": ["", "text/plain", "text/vtt"]}
  }
  return getMeetingsWithFilter(
          { "order_by": "createdAt", "order": "desc", "page": page, "limit": limit, "filters": filters },
          (response) => {
              let data = response.data;
              let records = data.records;
              let arr = []
              records.forEach((snap) => {
                  snap.createdAt = moment(snap.createdAt);
                  arr.push({...snap,id:snap.id,
                  notes:snap?.notes?.map((item)=>{
                      return {
                          name:item?.name?item.name:item,
                          completed:item?.completed?item.completed:false,
                          transName:item?.transName?item.transName:""
                      }
                  }),
                  questions:snap?.questions?.map((item)=>{
                      return {
                          name:item?.name?item.name:item,
                          completed:item?.completed?item.completed:false,
                          transName:item?.transName?item.transName:""
                      }
                  }),
                  })
              });
              data.records = arr;
              import("../redux/actions/uploadsActions").then((ac) =>
                dispatch(ac.setUploads(arr))
              );
              return data;
          },
          (error) => {}
      )
}